import React, { useMemo, useRef } from "react";
import { useDrag, useDrop } from "react-dnd";
import Colors from "../../../../../../assets/Colors";
import { MdMenu } from "react-icons/md";

const ListRow = ({
  setActiveStep,
  setSelectedRuleIndex,
  rule,
  index,
  moveRule,
}) => {
  const ref = useRef(null);

  const styles = useMemo(() => {
    return {
      rowContainer: {
        display: "flex",
        alignItems: "center",
        borderRadius: "8px",
      },
      rowContent: {
        width: "100%",
        height: "100%",
        cursor: "pointer",
      },
      rowDragButton: { cursor: "move", margin: "14px 14px" },
    };
  }, []);

  const [{ handlerId }, drop] = useDrop({
    accept: "row",
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId(),
      };
    },
    hover(item, monitor) {
      if (!ref.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;
      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return;
      }
      // Determine rectangle on screen
      const hoverBoundingRect = ref.current?.getBoundingClientRect();
      // Get vertical middle
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      // Determine mouse position
      const clientOffset = monitor.getClientOffset();
      // Get pixels to the top
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;
      // Only perform the move when the mouse has crossed half of the items height
      // When dragging downwards, only move when the cursor is below 50%
      // When dragging upwards, only move when the cursor is above 50%
      // Dragging downwards
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }
      // Dragging upwards
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }
      // Time to actually perform the action
      moveRule(dragIndex, hoverIndex);
      // Note: we're mutating the monitor item here!
      // Generally it's better to avoid mutations,
      // but it's good here for the sake of performance
      // to avoid expensive index searches.
      item.index = hoverIndex;
    },
  });

  const [{ isDragging }, drag] = useDrag({
    type: "row",
    item: () => {
      return { rule, index };
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });
  const opacity = isDragging ? 0 : 1;
  drag(drop(ref));

  return (
    <div
      ref={ref}
      style={{
        ...styles.rowContainer,
        backgroundColor: index % 2 === 0 ? Colors.bgGrey : "transparent",
        opacity,
      }}
      data-handler-id={handlerId}
    >
      <div style={styles.rowDragButton} ref={drag}>
        <MdMenu />
      </div>
      <div
        style={styles.rowContent}
        onClick={() => {
          setActiveStep("create_rule");
          setSelectedRuleIndex(index);
        }}
      >
        Rule {index + 1}
      </div>
    </div>
  );
};

export default ListRow;
